import { Reducer } from 'react';
import { handleReducer } from './index';
import { IMatch, IMatchState } from '@zmedia/bm-soccer-ui/interface';
import { IS_UPDATE_LIVE_MATCH, LIVE_MATCHES_UPDATE, LIVE_MATCH_UPDATE } from '@zmedia/bm-soccer-ui/redux/actions/match';

const STATE_DEFAULT: IMatchState = {
    items: [],
    shouldUpdate: false,
    currentItem: undefined
} as IMatchState;

const handler = {
    [LIVE_MATCHES_UPDATE]: (
        state: IMatchState,
        items: IMatch[]
    ): IMatchState => {
        return {
            ...state,
            items: items,

        };
    },
    [LIVE_MATCH_UPDATE]: (
        state: IMatchState,
        match: IMatch
    ): IMatchState => {
        return {
            ...state,
            currentItem: match
        };
    },
    [IS_UPDATE_LIVE_MATCH]: (
        state: IMatchState,
        shouldUpdate: boolean
    ): IMatchState => {
        return {
            ...state,
            shouldUpdate
        };
    },
};

const matchReducer: Reducer<any, any> = (state = STATE_DEFAULT, action: any) => {
    return handleReducer(handler, state, action);
};

export default matchReducer;
